// Value lists without dependencies, safe for the app's initial bundle
// (route search validation). Zod schemas live in the other modules.

export const itemTypes = ["material", "semi_finished", "finished_good", "service"] as const;
export const procurementTypes = ["purchase", "manufacture"] as const;
